import { TFunction } from "i18next";
import { FC } from "react";
import { useSeo } from "../../shared/components/UseSeoComponent";
import "./style.css";

interface ServicesPageProps {
  maxWidth: number;
  screenWidth: number;
  screenHeight: number;
  t: TFunction<"translation", undefined>;
}

const ServicesPage: FC<ServicesPageProps> = (props: ServicesPageProps) => {
  const { t, maxWidth, screenWidth, screenHeight } = props;
  useSeo("servicesPage");

  return (
    <div className="services-page-container" style={{ maxWidth: maxWidth }}>
      <h1 className="services-title">{t("servicesPage.title")}</h1>
      
      <div className="services-content">
        {/* Sözlü Çeviri */}
        <div className="services-column">
          <div className="service-category">
            <h3 className="category-title">{t("servicesPage.oralTranslation.title")}</h3>
            <ul className="service-list">
              {(t("servicesPage.oralTranslation.items", { returnObjects: true }) as string[]).map((item: string, index: number) => (
                <li key={index} className="service-item">{item}</li>
              ))}
            </ul>
          </div>
        </div>

        {/* Yazılı Çeviri */}
        <div className="services-column">
          <div className="service-category">
            <h3 className="category-title">{t("servicesPage.writtenTranslation.title")}</h3>
            <ul className="service-list">
              {(t("servicesPage.writtenTranslation.items", { returnObjects: true }) as string[]).map((item: string, index: number) => (
                <li key={index} className="service-item">{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>


    </div>
  );
};

export default ServicesPage; 